import React, { useEffect } from 'react'
import { Controller, useWatch } from 'react-hook-form'
import { judgeOpts } from '@ow/utils'
import dittoWeb from '../../ditto/register.field'
import FieldInfo, { unUseTitleTypes } from './field-info'

/**
 *
 * @param {*} fields 所有字段定义
 * @param {*} opts 当前字段定义
 * @param {*} defaultValue 默认值
 * @param {*} control 表单受控
 * @param {*} formControl 取值setValue可用来更新某个字段数据
 * @param {*} error 当前字段的错误信息
 * @param {*} models models
 * @param {*} widgets 无效参数
 * @param {*} isInline 是否展示行样式
 * @param {*} onClickUpload 上传文件
 * @param {*} onFetchRemoteData 获取表单、点位、指标model实列方法
 * @returns
 */
export const WebField = ({
  fields,
  opts,
  data,
  defaultValue,
  control,
  formControl,
  error,
  errors,
  models,
  widgets,
  isInline,
  matrix,
  detailData,
  refConditonFields,
  waterMarkDefs,
}) => {
  const Widget = dittoWeb.render(opts.type)
  let finalOpts = { ...opts, ...opts.fieldOpts }
  let values = []

  // 通过添加监听校验字段关联来修改opts
  if (opts.logicSpec) {
    // 添加监听
    const logicFields = opts.logicSpec.conditions.map((x) => x.slug)

    values = useWatch({
      control,
      name: logicFields,
    })

    finalOpts = judgeOpts({ opts, values, fields, defaultValues: data })

    if (refConditonFields) {
      refConditonFields.current = {
        ...refConditonFields.current,
        [finalOpts.slug]: values,
      }
    }
  }

  const { slug } = finalOpts
  // useEffect(() => {
  //   if (values.length > 0) {
  //     formControl.setValue(opts.slug, null)
  //   }
  // }, [values])

  useEffect(() => {
    if (!opts.logicSpec) return
    // 当因为logicSpec隐藏字段时，将表单里的值置空
    if (finalOpts.hiddenWhenCreate && formControl.getValues(slug)) {
      formControl.setValue(slug, null)
    }
  }, [opts.logicSpec, finalOpts.hiddenWhenCreate])

  if (finalOpts.hiddenWhenCreate) return null

  return (
    <FieldInfo error={error} opts={finalOpts} isInline={isInline}>
      {Widget && (
        <div
          style={{
            marginTop:
              !matrix && !unUseTitleTypes.includes(finalOpts.type) && '9px',
          }}
        >
          <Controller
            render={({ field }) => {
              return (
                <Widget
                  {...field}
                  opts={finalOpts}
                  models={models}
                  widgets={widgets}
                  fields={fields}
                  errors={errors}
                  formControl={formControl}
                  defaultValue={defaultValue}
                  data={data}
                  detailData={detailData}
                  waterMarkDefs={waterMarkDefs}
                  style={
                    isInline
                      ? {
                          border: 'none',
                          borderRadius: '0',
                          boxShadow: 'none',
                        }
                      : {}
                  }
                />
              )
            }}
            name={slug}
            rules={dittoWeb.validation(finalOpts)}
            control={control}
            defaultValue={finalOpts.defaultValue}
          />
        </div>
      )}
    </FieldInfo>
  )
}

export default WebField
